/**
 * @file desktopKeepControlLabel.ts
 * @description The text on the artifact toolbar's keep button, in one place.
 * Consumers: `resolveDesktopKeepControl`, which puts it on the button, and
 * `resolveAttachmentKeepToggle`, whose disabled tooltips send the reader to that
 * button by name.
 *
 * It is a function rather than two constants because the label depends on the
 * state, and the per-file tooltip has to name the label the toolbar carries in
 * the *same* state: an unpinned artifact reads "Keep on my computer", so a
 * tooltip saying "Use On my computer" would name a button nobody can see. The
 * attachments resolver imports this module directly rather than through the
 * folder's barrel, which would pull antd components into a pure resolver.
 */

export const desktopKeepControlLabel = (isPinned: boolean): string =>
    isPinned ? 'On my computer' : 'Keep on my computer';
